import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import config from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import house_icon from "../../assets/images/forgotpass_bg.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { showErrorToast, showSuccessToast } from "../utils";
import { useAuth } from "../../contexts/AuthContext";
import { useProfile } from "../../contexts/ProfileContext";

const PasswordFromToken = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [validationError, setValidationError] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    const { loginUserSuccess } = useAuth();
    const { fetchProfile } = useProfile();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");

        const passwordRegx = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/;
        if (!passwordRegx.test(newPassword)) {
            setValidationError(true);
            setLoading(false);
            return;
        } else {
            setValidationError(false);
        }

        if (newPassword !== confirmPassword) {
            showErrorToast("Passwords don’t match. Please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });

            setLoading(false);
            return;
        }

        const payload = {
            token: token,
            new_password: newPassword,
        };

        try {
            const response = await fetch(`${config.get("API_URL")}/user/reset-passwd-with-token`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data?.detail) {
                return showErrorToast(data?.detail, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            }

            showSuccessToast("Password reset successfully!", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            if (data.access_token) {
                // Store tokens in localStorage
                localStorage.setItem("authUser", JSON.stringify(data.access_token));
                localStorage.setItem("refreshToken", JSON.stringify(data.refresh_token));

                // Update AuthContext with login success
                loginUserSuccess({
                    user: data.user || {},
                    token: data.access_token,
                });

                // Fetch fresh profile data
                await fetchProfile();

                navigate("/properties", { replace: true });
            } else {
                navigate("/login");
            }
        } catch (error) {
            setMessage(error.message || "Error occurred");
            setMessageType("danger");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-main-wrapper">
            <div
                className="md:tw-bg-none tw-bg-center tw-bg-cover tw-w-full tw-h-full tw-flex tw-justify-between max-sm:tw-overflow-y-scroll"
                style={{ backgroundImage: `url(${house_icon})` }}
            >
                <div
                    style={{ backgroundImage: `url(${house_icon})` }}
                    className="max-sm:tw-hidden tw-relative tw-bg-center tw-bg-cover tw-w-full tw-m-2 "
                >
                    <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>

                    <div className="tw-absolute tw-top-[40px] tw-left-[30px] tw-flex tw-gap-2 tw-z-10">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c704c298b9ced9c12fdf92061da095dec0b48ab751d0dab56ea704d9d9b3733?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                            alt="AiRE BROKERS logo"
                            className="logo tw-w-[35px] tw-h-[35px]"
                        />
                        <span className={`brandName tw-text-[16px] `}>{config.get("COMPANY_NAME")}</span>
                    </div>
                </div>

                <div className="tw-h-full  max-sm:tw-h-fit tw-w-full max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px]  md:tw-px-10 max-sm:tw-px-5  max-sm:tw-mt-52 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 ">
                    <div className="md:tw-max-w-[526px] 2xl:tw-max-w-[721px] tw-h-full tw-items-center  tw-flex tw-justify-center tw-pt-5  tw-w-full max-sm:tw-mt-10 max-sm:tw-mb-3">
                        <form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-4  2xl:tw-gap-5 ">
                            <div className="tw-flex tw-flex-col tw-gap-[10px]">
                                <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[24px]">
                                    Reset Password
                                </h1>
                                <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-semi_dark_text max-sm:tw-font-thin">
                                    Set the new password for your account so you can login and access all features.
                                </p>
                            </div>

                            <div className="tw-flex tw-flex-col tw-gap-3 2xl:tw-gap-6">
                                <div className=" tw-w-full tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                    <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Password</span>
                                    <div className="tw-relative ">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            required
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            placeholder="Enter New Password"
                                            className="tw-px-3 tw-pr-12 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                        />
                                        {validationError && (
                                            <p className="tw-text-red-600 tw-text-[12px]">
                                                *Minimum 8 characters, including at least one letter and one number
                                            </p>
                                        )}

                                        {/* Toggle Button */}
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            className="tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2"
                                        >
                                            {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                        </button>
                                    </div>
                                </div>

                                <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                    <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Confirm Password</span>
                                    <div className="tw-relative">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            required
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            placeholder="Enter Confirm Password"
                                            className="tw-px-3 tw-pr-12 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                        />

                                        {/* Toggle Button */}
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                                            className="tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2"
                                        >
                                            {showConfirmPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-flex tw-flex-col">
                                <button
                                    // onClick={handleSubmit}
                                    type="submit"
                                    className="tw tw-bg-primary hover:tw-bg-primary_hover tw-border-none tw-text-white tw-mt-5 tw-p-3 tw-rounded-md"
                                    disabled={loading ? true : false}
                                >
                                    {loading ? <Spinner size="sm" color="light" /> : "Reset Password"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordFromToken;
